import { fetchApiPorsche } from './fetchApiPorsche'

export function getPorsche(url, options) {
  return fetchApiPorsche(url, {
    ...options,
    method: 'GET',
  })
}
